export default "__VITE_ASSET__63c265ba__"